var React = require('react');

function Login (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"nonzero"},[React.createElement("path",{"d":"M20.738 16H1.02a1.02 1.02 0 010-2.04h19.718a1.02 1.02 0 010 2.04z","key":0}),React.createElement("path",{"d":"M15.298 21.439a1.02 1.02 0 01-.72-1.742l4.718-4.719-4.719-4.718a1.02 1.02 0 011.443-1.443l5.44 5.44a1.02 1.02 0 010 1.442l-5.44 5.44c-.2.2-.46.3-.722.3z","key":1}),React.createElement("path",{"d":"M16.318 29.938c-6.189 0-11.652-3.723-13.922-9.486a1.02 1.02 0 111.898-.745c1.96 4.975 6.68 8.191 12.024 8.191 7.123 0 12.919-5.796 12.919-12.918 0-7.123-5.796-12.92-12.919-12.92-5.344 0-10.064 3.217-12.024 8.193a1.02 1.02 0 11-1.898-.745C4.666 3.744 10.13.02 16.318.02c8.248 0 14.959 6.711 14.959 14.959 0 8.247-6.711 14.958-14.959 14.958z","key":2})]));
}

Login.defaultProps = {"viewBox":"0 0 32 30"};

module.exports = Login;

Login.default = Login;
